export const TRIP_REQUEST_EMBED_KB_URL =
  'https://bambi-knowledge-base.help.usepylon.com/articles/1105064968-setting-up-your-trip-request-form-for-a-website';

export const EMBED_COPY_WARNING =
  'Copy this entire code block as-is. Do not extract the URL to use as a link. It will not work.';
